export var initForm = function initForm() {
  var _document$querySelect;

  (_document$querySelect = document.querySelector(".contact-form__hide-feedback")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.addEventListener("click", function () {
    document.querySelector(".wpcf7-form").dataset.status = "init";
  });
};